import { aiAssistantPages } from './prototypes/easm-platform/ai-assistant/ai-assistant.routes';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideSolAuthentication,
  provideSolComponents,
  provideSolDebug,
  provideSolHttpClient,
  provideSolLocale,
  provideSolNavigation,
  provideSolStorage,
  provideSolTheme,
  Theme,
} from '@sol/components';
import { environment } from '../environments/environment';
import * as packageJson from '../../package.json';
import { apps } from './apps';
import { routes } from './app.routes';
import { provideAnnotationNotesViews } from './prototypes/annotation-notes/providers/provide-annotation-notes-views';
import { provideWebContentV2Views } from './prototypes/webcontent-v2/providers/provide-webcontent-v2-views';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    ...provideSolHttpClient(),
    provideSolComponents(packageJson.version, (viewService, typeService) => {
      provideAnnotationNotesViews(viewService, typeService);
      provideWebContentV2Views(viewService, typeService);
    }),
    provideSolDebug(environment.ENV),
    ...(environment.KEYCLOAK_URL
      ? [
          provideSolAuthentication({
            url: environment.KEYCLOAK_URL,
            realm: environment.KEYCLOAK_REALM,
            clientId: environment.KEYCLOAK_CLIENT_ID,
          }),
        ]
      : []),
    provideSolStorage(environment.APP),
    provideSolTheme(Theme.SOL_DARK),
    provideSolNavigation(apps, [...routes, ...aiAssistantPages], environment),
    provideSolLocale(['asm-prototype', 'asm-components-core', 'sol-components']),
  ],
};
